"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HYTOPIAClient = void 0;
const auth_1 = __importDefault(require("./auth"));
const bank_1 = require("./bank");
const play_1 = require("./play");
const social_1 = __importDefault(require("./social"));
const items_1 = require("./items");
const locker_1 = require("./locker");
const search_1 = require("./search");
const marketplace_1 = require("./marketplace");
const notifications_1 = require("./notifications");
const polygonMigrations_1 = __importDefault(require("./polygonMigrations"));
const system_1 = require("./system");
class HYTOPIAClient {
    auth;
    bank;
    play;
    items;
    locker;
    search;
    social;
    system;
    marketplace;
    notifications;
    polygonMigrations;
    constructor(baseUrl, notificationsSocketUrl, socialSocketUrl) {
        this.auth = new auth_1.default(baseUrl);
        this.bank = new bank_1.BankAPI(baseUrl);
        this.play = new play_1.PlayAPI(baseUrl);
        this.items = new items_1.ItemsAPI(baseUrl);
        this.locker = new locker_1.LockerAPI(baseUrl);
        this.search = new search_1.SearchAPI(baseUrl);
        this.social = new social_1.default(baseUrl, socialSocketUrl ?? baseUrl);
        this.system = new system_1.SystemAPI(baseUrl);
        this.marketplace = new marketplace_1.MarketplaceAPI(baseUrl);
        this.notifications = new notifications_1.NotificationsAPI(baseUrl, notificationsSocketUrl ?? baseUrl);
        this.polygonMigrations = new polygonMigrations_1.default(baseUrl);
    }
}
exports.HYTOPIAClient = HYTOPIAClient;
//# sourceMappingURL=index.js.map